import React, { Component } from "react";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tr from "date-fns/locale/tr";
import {
  getMyDemands,
  selectWorkflow,
} from "../../../state/ducks/workflow/index";
import $ from "jquery";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-bootstrap.css";
import RenderDemandDetail from "./RenderDemandDetail";
import StaticModal from "../shared/StaticModal";

export class MyDemands extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: "Talep No",
          field: "talepNo",
          sortable: true,
          width: 110,
          suppressSizeToFit: true,
          unSortIcon: true,
        },
        {
          headerName: "Konu",
          field: "konu",
          width: 150,
          sortable: true,
          suppressSizeToFit: true,
          unSortIcon: true,
        },
        {
          headerName: "Açılma Tarihi",
          field: "acilisTarihi",
          sortable: true,
          width: 140,
          suppressSizeToFit: true,
          unSortIcon: true,
          valueFormatter: dateFormatter,
        },
        {
          headerName: "Durumu",
          field: "durumu",
          sortable: true,
          width: 90,
          suppressSizeToFit: true,
          unSortIcon: true,
        },
        {
          headerName: "",
          field: "value",
          cellRenderer: "childMessageRenderer",
          colId: "params",
          width: 130,
          suppressSizeToFit: true,
        },
      ],
      localeText: {
        page: "Sayfa",
        contains: "İçeren",
        notContains: "İçermeyen",
        of: " / ",
        to: "ile",
        equals: "Eşit",
        notEqual: "Eşit Değil",
        startsWith: "Başlar",
        endsWith: "Biter",
        noRowsToShow: "Talep bulunamadı.",
        loadingOoo: "Yükleniyor...",
      },
      frameworkComponents: {
        childMessageRenderer: RenderDemandDetail,
      },
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  state = {
    demands: [],
    startDate: "",
    endDate: "",
  };

  componentWillReceiveProps(nextProps) {
    if(this.state.startDate == undefined && this.state.endDate ==undefined){
    this.setState({
      demands: nextProps.workflow.list,

    });
    }
  }

  componentDidMount() {
    this.props.getMyDemands();
    $(".react-datepicker-wrapper").addClass("form-control");
    $(".ag-paging-row-summary-panel").html(<span></span>);
  }

  filterList = () => {
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    let demands = this.props.workflow.list;

    if (demands!==undefined) {
      let result = demands.filter((item) => {
        if (startDate != "" && startDate != null) {
          return new Date(item.acilisTarihi) >= startDate;
        } else {
          return item;
        }
      });

      if (endDate != "" && endDate != null) {
        result = result.filter((item) => {
          let createDate = new Date(item.acilisTarihi);
          return (
            new Date(
              createDate.getFullYear(),
              createDate.getMonth(),
              createDate.getDate()
            ) <= endDate
          );
        });
      }
      this.setState({ demands: result });
    }
    else{
      $("#hata_mesaji").modal("show");
    }
  };

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEnd = (date) => {
    this.setState({
      endDate: date,
    });
  };

  render() {
    return (
      <div className="container-fluid">
        {/* yesil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backtop"
                style={{
                  backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-search1 icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                      Taleplerim
                    </div>
                    <span className="altBaslik">Talep Takibi</span>
                  </div>
                </div>
                <div className="row no-gutters pb-4 justify-content-between">
                  <div className="col-12 pb-1">
                    <span className="t-icInputTitle pl-3">Açılma Tarihi aralığı</span>
                  </div>
                  <div className="col-5 pr-3 m-takvim">
                    <div className="input-group ">
                      <div className="input-group-prepend" onClick={e => $(".tarih_formatStart").focus()}>
                        <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                          <i className="t-icon-calendar1"></i>
                        </span>
                      </div>
                      <DatePicker
                        className="tarih_formatStart m-datepicker"
                        selected={this.state.startDate}
                        dateFormat="dd.MM.yyyy"
                        popperClassName="form"
                        calendarClassName="rasta-stripes"
                        locale={tr}
                        value={this.state.startDate}
                        placeholder="Başlangıç Tarihi"
                        required
                        onChange={this.handleChange}
                      />
                    
                    </div>
                    
                  </div>
                  <div className="col-5 pr-3 m-takvim">


                    <div className="input-group">
                      <div className="input-group-prepend" onClick={e => $(".tarih_formatEnd").focus()}>
                        <span className="input-group-text m-takvimiconhizalama" id="basic-addon2">
                          <i className="t-icon-calendar1"></i>
                        </span>
                      </div>
                      <DatePicker
                        className="tarih_formatEnd m-datepicker"
                        selected={this.state.endDate}
                        dateFormat="dd.MM.yyyy"
                        locale={tr}
                        value={this.state.endDate}
                        placeholder="Bitiş Tarihi"
                        required
                        onChange={this.handleChangeEnd}
                      />
                    </div>

                  </div>
                  <div className="col-2">
                    <button className="t-icButtonYesil"
                      onClick={this.filterList}>
                      <span>Getir</span>
                      <i className="t-icon-arrow-right2" />
                    </button>
                  </div>
                </div>
                <div className="row no-gutters">
                  {/* Tablo*/}
                  <div className="col-12">
                    <div
                      hidden={this.state?.demands == null || this.state?.demands?.length <= 0}
                      className="ag-theme-bootstrap t-tablo"
                      style={{
                        width: "100%",
                        height: "400px",
                      }}
                    >
                      <AgGridReact
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.demands}
                        pagination={true}
                        paginationAutoPageSize={true}
                        localeText={this.state.localeText}
                        frameworkComponents={this.state.frameworkComponents}
                        rowHeight={30}
                        headerHeight={30}
                        animateRows={true}
                        onGridReady={this.onGridReady}
                      ></AgGridReact>
                      <span className="float-right" id="totalRowCount">
                        Toplam Talep: <strong>{this.state?.demands?.length}</strong>
                      </span>
                    </div>
                    {/* STRANDART SORT YAPILAN TABLE BİTTİ -----------   */}
                  </div>

                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <StaticModal></StaticModal>
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}

function dateFormatter(params) {
  return new Date(params.value).toLocaleString();
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMyDemands: () => dispatch(getMyDemands()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyDemands);
